import { reducer as app } from './modules/app';
import { reducer as adminForms } from './modules/adminForms';
import { reducer as errors } from './modules/errors';
import { reducer as settingsApp } from './modules/settingsApp';
import { reducer as settingsApprovals } from './modules/settingsApprovals';
import { reducer as settingsDatastore } from './modules/settingsDatastore';
import { reducer as settingsNotifications } from './modules/settingsNotifications';
import { reducer as settingsRobots } from './modules/settingsRobots';
import { reducer as settingsUsers } from './modules/settingsUsers';
import { reducer as settingsCalendars } from './modules/settingsCalendars';

export default {
  app,
  adminForms,
  errors,
  settingsApp,
  settingsApprovals,
  settingsDatastore,
  settingsNotifications,
  settingsRobots,
  settingsUsers,
  settingsCalendars,
};
